<template>
  <div class="angrybirds">
    <h1>Демонстрация движения тела под углом к горизонту</h1>
    <div id="box">
      <canvas id="canvas1" class="part" width="878px" height="659px"></canvas>
      <canvas id="canvas2" class="part" width="878px" height="659px"></canvas>
    </div>
    <div>
      <div>Параметр А параболы: <input type="text" v-model="a" /></div>
      <div>Параметр B параболы: <input type="text" v-model="b" /></div>
      <div>Параметр C параболы: <input type="text" v-model="c" /></div>
      <div>Скорость анимации, мс: <input type="text" v-model="velocity" /></div>
      <div>Координата X: <input type="text" v-model="x" /></div>
      <div>Координата Y: <input type="text" v-model="y" /></div>
      <button v-on:click="run_again">Кликни меня для запуска</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "AngryBirds",
  data() {
    return {
      a: -0.95,
      b: -32.0,
      c: 0.0,
      velocity: 100,
      x: 0
    };
  },
  computed: {
    y: function() {
      return this.a * this.x * this.x - this.b * this.x + this.c;
      // return this.x;
    },
    coordX: function() {
      return 80 + 25 * this.x;
    },
    coordY: function() {
      return 350 - this.y;
    }
  },
  methods: {
    loadImageFromFile(url) {
      var img = new Image();
      img.src = url;
      return img;
    },
    birdUrl() {
      return require("@/assets/bird1.png");
    },
    drawImage(object) {
      var canvas = document.getElementById("canvas2");
      var context = canvas.getContext("2d");
      context.drawImage(object, this.coordX, this.coordY);
    },
    clearCanvas() {
      var canvas = document.getElementById("canvas2");
      var context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    },
    run_again() {
      this.x = 0;
      this.$nextTick(function() {
        window.setInterval(() => {
          this.countDown();
        }, this.velocity);
      });
    },
    countDown() {
      this.clearCanvas();
      var myImg = this.loadImageFromFile(this.birdUrl());

      this.drawImage(myImg);

      this.x += 1;
      if (this.x > 35) {
        // TODO: Stop
        this.x = 5000;
      }
    }
  }
};
</script>

<style scoped>
#box {
  width: 878px;
  height: 659px;
  position: relative;
  margin-bottom: 20px;
}
.part {
  position: absolute;
}
#canvas1 {
  left: 0;
  top: 0;
  background: url("../assets/background.jpg");
}
#canvas2 {
  left: 0;
  top: 0;
}
</style>
